import React from 'react'
import Product from './comp-prod'
import './style.css'

export default function Bayar() {

    return (
        <div className="componenet-bayar">
            <div>
                <Product />
                <div className="time-later-product mt-5">
                    <h3>Pesanan dibatalkan</h3>
                </div>
            </div>
            <div className="pembayaran">
                <h6>Dibatalkan</h6>
                <p>Total yang harus dibayar</p>
                <h2>Rp. 160.000</h2>
                <div className="group-tombol">
                <button type="button">Beli Lagi</button>
                <a href="https:wa.me/+6285349780521" target="_blank" rel="noopener noreferrer"> 
                    <button type="button" target="_blank">Hubungi Toko</button>
                </a>
                </div>
            </div>
        </div>
    )
}
